/**
 * jsName:index_controller.js
 * author:liuximei
 * date:2016-09-18
 * use:Swisse跨境购首页
**/
"use strict";
var mama100App = angular.module('mama100App', ['ngCookies','lazyload','angular-carousel']);
mama100App.controller("index_controller",['$scope', '$http','$cookies','$timeout',function ($scope,$http,$cookies,$timeout) {
    init($scope,$http,$cookies,$timeout);
    window.onbeforeunload = function() {
        if (mama.device.platform == 'android') {
            history.scrollRestoration = 'manual';
        }
    }
    $scope.onCategoryClick=function(classifyId,event){
        prevent(event);
        if(classifyId){
            for(var i=0,len=$scope.classifyList.length;i<len;i++){
                if($scope.classifyList[i].id==classifyId){
                    var url = location.href.split("home/index.html",2)[0]+"o2o/product4.2/products_list_v4.1.html?auth=0&categoryName="+encodeURIComponent($scope.classifyList[i].name)+"&crmCategoryId="+$scope.classifyList[i].id+"&themeId="+$scope.classifyList[i].themeId;
                    window.location.href = url;
                    break;
                }
            }
        }else{//全部商品
            $scope.allProduct();
        }
    };
    $scope.allProduct=function(){
        window.location.href = location.href.split("home/index.html",2)[0]+"o2o/product4.2/products_list_v4.1.html?auth=0&categoryName="+encodeURIComponent("全部商品")+"&crmCategoryId=0";
    };
    $scope.goToSpecialSalesDetail = function(spu){
        var url = location.href.split("home/index.html",2)[0]+"o2o/product4.2/products_detail_v4.2.html?prodId="+spu+"&terminalCode="+$scope.terminalCode;
        window.location.href = url;
    };
    $scope.healthPlan = function(spu,url){
        if(spu){
            $scope.goToSpecialSalesDetail(spu);
        }else if(url){
            window.location.href = url;
        }
    };
    $scope.bannerLink=function(pic){
        if(pic.type&&pic.type==1){//sku跳转
            location.href=location.href.split("home/index.html",2)[0]+"o2o/product4.2/products_detail_v4.2.html?prodId="+pic.spu+"&terminalCode="+pic.terminalCode;
        }else{//链接跳转
            location.href=pic.wxUrl;
        }
    };
    $scope.couponList=function(event){
        prevent(event);
        var url;
        if($cookies.token){
            url= location.href.split("home/index.html",2)[0]+"coupon/myCoupon.html?fromePage=myCoupon";
        }else{
            url=location.href.split("home/index.html",2)[0]+"center/myAccount/add_customer.html";
        }
        window.location.href = url;
    };
    $scope.activeList=function(event){
        prevent(event);
        var url = location.href.split("home/index.html",2)[0]+"activityDemo/activeList2/activeList.html?terminalCode="+$scope.terminalCode;
        window.location.href = url;
    };
    $scope.orderList=function(event){
        prevent(event);
        var url;
        if($cookies.token){
            url= location.href.split("home/index.html",2)[0]+"center/order/index.html";
        }else{
            url=location.href.split("home/index.html",2)[0]+"center/myAccount/add_customer.html";
        }
        window.location.href = url;
    };
    $scope.goShopingCar=function(event){
        prevent(event);
        var url;
        if($cookies.token){
            url=location.href.split("home/index.html",2)[0]+"o2o/product4.2/shopping_cart.html";
        }else{
            url=location.href.split("home/index.html",2)[0]+"center/myAccount/add_customer.html";
        }
        window.location.href = url;
    };
    $scope.search=function(event){
        prevent(event);
        window.location.href = "search.html";
    };
    $scope.groupBuy=function(event,activityId){
        prevent(event);
        var url = location.href.split("home/index.html",2)[0]+"groupBuy/join/addGroupBuy.html?activityId="+activityId+"&terminalCode="+$scope.terminalCode;
        window.location.href = url;
    };
    $scope.myGroupBuy=function(event){
        prevent(event);
        var url = location.href.split("home/index.html",2)[0]+"groupBuy/order/status.html";
        window.location.href = url;
    };
    $scope.menuLink=function(menu){
        prevent(event);
        if(menu.id){
            if(menu.type&&menu.type==1){//sku跳转
                location.href=location.href.split("home/index.html",2)[0]+"o2o/product4.2/products_detail_v4.2.html?prodId="+menu.spu+"&terminalCode="+menu.terminalCode;
            }else{//链接跳转
                location.href=menu.url;
            }
        }
    };
    //打开营业执照
    /*$scope.goStoreLicense=function (event) {
        if(event) event.stopPropagation();
        if (ShareSDK&&ShareSDK.previewImage) {
            var img=location.href.split("home/index.html",2)[0]+'home/images/business_license.jpg';
            ShareSDK.previewImage([img]);
        }
    };*/
}]);
/**
 * 初始化
 * @param $http
 * @param $scope
 */
function init($scope,$http,$cookies,$timeout){
    if(!$cookies.openId){
        setTimeout(function(){
            showAuth_swisse($http,$cookies);
        },300);
        return;
    }
    $scope.groupBuyImg_url=groupBuyImg_url;
    $scope.terminalCode=getQueryString("terminalCode");
    var guideCode=getQueryString("guideCode");
    if(guideCode){
        sessionStorage.setItem('guideCode',guideCode);
    }
    var terminalCode=sessionStorage.getItem("ext_term_Code");
    if(!$scope.terminalCode&&terminalCode){
        $scope.terminalCode=terminalCode;
    }else if(($scope.terminalCode&&!terminalCode)||(terminalCode&&$scope.terminalCode&&terminalCode!=$scope.terminalCode)){
        sessionStorage.setItem('ext_term_Code',$scope.terminalCode);
    }
    $scope.couponMount='--';
    $scope.orderCount='--';
    $scope.classifyList=[];//商品分类列表
    $scope.locadBannerSuccess=false;//是否加载完banner
    $scope.menuItems=[];//头部tab列表
    $scope.matchPlanList=[];//搭配法则列表
    $scope.hotCategoryList=[];//搭配法则列表
    /*分享设置*/
    try{
        var shareConfig = {
            shareTit:"Swisse专区，健康美丽“购”不停",
            shareDesc:"Swisse让您更健康,更快乐。Live Healthy,Be Happy.",
            shareURL:window.location.href.split("?",2)[0]+"?terminalCode="+$scope.terminalCode,
            shareImg:window.location.href.replace("index.html","images/shareLogo.png")
        };
        commonShare(shareConfig.shareTit,shareConfig.shareDesc,shareConfig.shareDesc,shareConfig.shareURL,shareConfig.shareImg);
    }catch(e){
        alert(e)
    }
    queryTerminalShort($scope,$http,$cookies);
    queryBanner($http,$scope,$cookies);
    queryActive($http,$scope,$cookies);
    groupBuyActive($http,$scope,$cookies,function(){
        groupBuyPreActive($http,$scope,$cookies);
    });
    getAllCategory($scope,$http,$cookies);

    getTopMenu($scope,$http,$cookies);
    getBroadcastContent($scope,$http,$cookies);
    getMatchPlan($scope,$http,$cookies);
    getHotCategory($scope,$http,$cookies);

    validateSwisseIndex(function(){
        getProdAmount($scope,$http,$cookies);
        queryMyCouponList($scope,$http,$cookies);
    }, $http, $cookies);
}
/**
 * 查询首页banner
 * @param $http
 * @param $scope
 */
function queryBanner($http,$scope,$cookies){
    showLoading();
    var data = {
        "tsno":mama.getTsno(),
        "openId":$cookies.openId,
        "terminalCode":$scope.terminalCode,
        "position":1
    };
    $http({
        method: 'POST',
        url: SWISSE_BASE_URL+"swisse-store/act/findActConfig",
        data: data
    }).success(function(data, status, headers, config){
        hideLoading();
        $scope.locadBannerSuccess=true;
        if(data.code==100){
            $scope.bannerList= data.actConfigList;
            if($scope.bannerList.length>5){
                $scope.bannerList.length=5;
            }
        }else{
            toastMessage(data.desc);
        }
    }).error(function(data, status, headers, config){
        hideLoading();
        showErrorMessage(status);
    });
}
/**
 * 查询活动数量
 * @param $http
 * @param $scope
 */
function queryActive($http,$scope,$cookies){
    showLoading();
    var data = {
        "tsno":mama.getTsno(),
        "openId":$cookies.openId,
        "terminalCode":$scope.terminalCode,
        "position":2
    };
    $http({
        method: 'POST',
        url: SWISSE_BASE_URL+"swisse-store/act/findActConfig",
        data: data
    }).success(function(data, status, headers, config){
        hideLoading();
        if(data.code==100){
            $scope.onActiveList= data.actConfigList;
        }else{
            toastMessage(data.desc);
        }
    }).error(function(data, status, headers, config){
        hideLoading();
        showErrorMessage(status);
    });
}
/**
 *查询进行中的拼团活动
 * @param $http
 * @param $scope
 */
function groupBuyActive($http,$scope,$cookies,callback){
    showLoading();
    $http({
        method: 'GET',
        url: SWISSE_BASE_URL + "snsec-groupon/groupon/activity/getActivitys/2/"+$scope.terminalCode
    }).success(function(data, status, headers, config){
        hideLoading();
        if(data.code==100){
            var groupBuyList=[];
            if(data.data&&data.data.length>0){
                for(var k=0,leng=data.data.length;k<leng;k++){
                    if(data.data[k].showInOfficial==0){
                        groupBuyList.push(data.data[k]);
                    }
                }
            }
            $scope.groupBuyList=groupBuyList;
            callback&&callback();
        }else{
            toastMessage(data.desc);
        }
    }).error(function(data, status, headers, config){
        hideLoading();
        showErrorMessage(status);
    });
}
/**
 *查询预热中的拼团活动
 * @param $http
 * @param $scope
 */
function groupBuyPreActive($http,$scope,$cookies,$timeout){
    showLoading();
    $http({
        method: 'GET',
        url: SWISSE_BASE_URL + "snsec-groupon/groupon/activity/getPreActivitys/2/"+$scope.terminalCode
    }).success(function(data, status, headers, config){
        hideLoading();
        if(data.code==100){
            if(data.data&&data.data.length>0){
                for(var i=0,len=data.data.length;i<data.data.length;i++){
                    if(data.data[i].showInOfficial==0){
                        $scope.groupBuyList.push(data.data[i]);
                    }
                }
            }
        }else{
            toastMessage(data.desc);
        }
    }).error(function(data, status, headers, config){
        hideLoading();
        showErrorMessage(status);
    });
}
/**
 * 获取分类列表
 * @param $http
 * @param $scope
 */
function getAllCategory($scope,$http,$cookies){
    showLoading();
    var data = {
        "tsno" : mama.getTsno(),
        "terminalCode":$scope.terminalCode
    };
    $http({
        method: 'POST',
        url:SWISSE_BASE_URL+'swisse-store/product/getAllCategory',
        data: data
    }).success(function(data, status, headers, config){
        if(data.code==100){
            $scope.classifyList=data.categoryList;
            if($scope.classifyList&&$scope.classifyList.length>0){
                $scope.classifyListSort=[];
                var pushIndex=0;
                for(var i=0,len=$scope.classifyList.length;i<len;i++){
                    if($scope.classifyList[i].name=="新品推荐"){//新品分类
                        querySpuList($http,$scope,$cookies,i);
                    }else{
                        var idx=parseInt(pushIndex/6);
                        if(pushIndex%6==0){
                            $scope.classifyListSort.push([]);
                        }
                        $scope.classifyListSort[idx].push($scope.classifyList[i]);
                        pushIndex++;
                    }
                }
                /*添加全部选项*/
                var lastPage=$scope.classifyListSort[$scope.classifyListSort.length-1],
                    allProduct={
                        id:0,
                        name:"全部产品",
                        pic:"images/classify12.jpg",
                        themeId:0
                    };
                if(lastPage&&lastPage.length<=5){
                    $scope.classifyListSort[$scope.classifyListSort.length-1].push(allProduct);
                }else if(lastPage&&lastPage.length==6){
                    $scope.classifyListSort.push([allProduct]);
                }
            }
        }
    }).error(function(data, status, headers, config){
        hideLoading();
        showErrorMessage(status);
    });
}

/**
 * 查询商品列表
 * @param $http
 * @param $scope
 */
function querySpuList($http,$scope,$cookies,index){
     var data = {
        "tsno":mama.getTsno(),
        "openId":$cookies.openId,
        "accessToken":"",
        "authData":"",
        "categoryId":$scope.classifyList[index].id,
        "seq":"5",//默认智能排序  1-人气 2-销量 3-价格 5-按商品库的排序
        "seqType":"0",//0-倒序 默认倒序，1-升序
        "pageSize":"10",
        "page":"1",
        "terminalCode":$scope.terminalCode,
        "themeId":$scope.classifyList[index].themeId
    };
    $http({
        method: 'POST',
        url: SWISSE_BASE_URL+"swisse-store/product/querySwisseSpuList",
        data: data
    }).success(function(data, status, headers, config){
        if(data.code==100){
            $scope.prdBeanList = data.mainSpuInfoList;
        }else{
            toastMessage(data.desc);
        }
    }).error(function(data, status, headers, config){
        showErrorMessage(status);
    });
}
/**
 * 查询是否有token
 * ***/
function validateSwisseIndex(callback,$http,$cookies){
    if($cookies.customerId&&$cookies.token){
        callback();
    }else{
        loadMemberIndex(callback,$http,$cookies);
    }
}

/**
 * 获取customerId
 * ***/
function loadMemberIndex(callback,$http,$cookies){
    showLoading();
    var data = {
        "openId":$cookies.openId,
        "tsno": new Date().getTime()
    };
    var url = BASICURL+'cust/getCustomer';
    $http({
        method: 'POST',
        url: url,
        data: data,
        headers: {
            'Content-Type': 'application/json'
        }
    }).success(function (data, status, headers, config){
        hideLoading();
        if (data.code == 100) {
            /*setCookieFit('customerId',data.id,24*60);*/
            getTokenIndex(callback,$http,$cookies.openId,data.id);
        }
    }).error(function (data, status, headers, config) {
        hideLoading();
        showErrorMessage(status);
    });
}
/**
 * 获取token
 * @param $scope
 * @param $http
 * @param $cookies
 */
function getTokenIndex(callback,$http,openId,customerId){
    showLoading();
    var url = SWISSE_BASE_URL + "swisse-store/accesstoken/getAccessToken";
    var data = {
        "openId":openId
    };
    $http({
        method: 'POST',
        url: url,
        data: data
    }).success(function(data, status, headers, config) {
        hideLoading();
        if (data.code == '100'){
            /*setCookieFit('token',data.accessToken,23*60);*/
            setTimeout(function(){
                callback();
            },1000);
        } else {
            mama.dialog.message("获取用户token出错：" + data.desc);
        }
    }).error(function(data, status, headers, config) {
        hideLoading();
        mama.dialog.error("获取数据失败：",status);
    });
}
/**
 * 查询我的优惠券列表
 * @param $http
 * @param $scope
 */
function queryMyCouponList($scope,$http,$cookies){
    showLoading();
     var inputData = {
		"openId":$cookies.openId,
        "tsno":mama.getTsno(),
        "customerId":$cookies.customerId,
        "terminalCode":$scope.terminalCode,
        "pageNo":1,
        "pageSize":100
    };
    $http({
        method: 'POST',
        url: SWISSE_BASE_URL+"swisse-store/coupon/queryMyCoupon",
        data: inputData
    }).success(function(data, status, headers, config){
        hideLoading();
        if(data.code==100){
            $scope.couponMount=data.couponBeanList.length;
        }else{
            toastMessage(data.desc);
        }
    }).error(function(data, status, headers, config){
        hideLoading();
        showErrorMessage(status);
    });
}

/**
 * 查询门店名称
 * @param $http
 * @param $scope
 */
function queryTerminalShort($scope,$http,$cookies){
    showLoading();
     var inputData = {
        "tsno":mama.getTsno(),
        "terminalCode":$scope.terminalCode
    };
    $http({
        method: 'POST',
        url: SWISSE_BASE_URL+"swisse-store/terminal/queryTerminalShort",
        data: inputData
    }).success(function(data, status, headers, config){
        hideLoading();
        if(data.code==100){
            if(data.shortName){
                document.title=data.shortName+document.title;
                if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
                     var i = document.createElement('iframe');
                     i.src = '/favicon.ico';
                     i.style.display = 'none';
                     i.onload = function() {
                         setTimeout(function(){
                              i.remove();
                         }, 9);
                     };
                     document.body.appendChild(i);
                }
            }
        }
    }).error(function(data, status, headers, config){
        hideLoading();
        showErrorMessage(status);
    });
}

/**
 * 获取广播内容
 * @param $http
 * @param $scope
 */
function getBroadcastContent($scope,$http,$cookies){
    showLoading();
    var inputData = {
        "openId":$cookies.openId,
        "tsno":mama.getTsno(),
        "terminalCode":$scope.terminalCode
    };
    $http({
        method: 'POST',
        url: SWISSE_BASE_URL+"swisse-store/home/broadcastContent",
        data: inputData
    }).success(function(data, status, headers, config){
        hideLoading();
        if(data.code==100){
            $scope.broadcastContent=data.value;
            try{
                setTimeout(function(){
                    var aa=document.querySelector(".tips_marquee"),
                        bb=aa.offsetWidth,
                        cc=document.querySelector(".tips_text").offsetWidth,
                        per=parseInt(cc/bb);
                        setInterval(function(){
                            if(aa.style.textIndent&&aa.style.textIndent!=="100%"){
                                var intent=parseInt(aa.style.textIndent.split("px")[0]);
                                if(-intent>=cc){
                                    aa.style.textIndent=bb+"px";
                                }else{
                                    aa.style.textIndent=(parseInt(intent)-1)+"px";
                                }
                            }else{
                                aa.style.textIndent=bb+"px";
                            }
                        },30)
                },800)
            }catch(e){
                console.log(e)
            }
        }else{
            toastMessage(data.desc);
        }
    }).error(function(data, status, headers, config){
        hideLoading();
        showErrorMessage(status);
    });
}

/**
 * 获取热销单品分类
 * @param $http
 * @param $scope
 */
function getHotCategory($scope,$http,$cookies){
    showLoading();
    var inputData = {
        "openId":$cookies.openId,
        "tsno":mama.getTsno(),
        "terminalCode":$scope.terminalCode
    };
    $http({
        method: 'POST',
        url: SWISSE_BASE_URL+"swisse-store/home/hotCategory",
        data: inputData
    }).success(function(data, status, headers, config){
        hideLoading();
        if(data.code==100){
            if(data.items&&data.items.length>0){
                $scope.hotCategoryList=data.items;
            }
        }else{
            toastMessage(data.desc);
        }
    }).error(function(data, status, headers, config){
        hideLoading();
        showErrorMessage(status);
    });
}
/**
 * 获取搭配法则
 * @param $http
 * @param $scope
 */
function getMatchPlan($scope,$http,$cookies){
    showLoading();
    var inputData = {
        "openId":$cookies.openId,
        "tsno":mama.getTsno(),
        "terminalCode":$scope.terminalCode
    };
    $http({
        method: 'POST',
        url: SWISSE_BASE_URL+"swisse-store/home/matchPlan",
        data: inputData
    }).success(function(data, status, headers, config){
        hideLoading();
        if(data.code==100){
            if(data.items&&data.items.length>0){
                $scope.matchPlanList=data.items;
            }
        }else{
            toastMessage(data.desc);
        }
    }).error(function(data, status, headers, config){
        hideLoading();
        showErrorMessage(status);
    });
}
/**
 * 获取顶部菜单
 * @param $http
 * @param $scope
 */
function getTopMenu($scope,$http,$cookies){
    showLoading();
    var inputData = {
        "openId":$cookies.openId,
        "tsno":mama.getTsno(),
        "terminalCode":$scope.terminalCode
    };
    $http({
        method: 'POST',
        url: SWISSE_BASE_URL+"swisse-store/home/topMenu",
        data: inputData
    }).success(function(data, status, headers, config){
        hideLoading();
        if(data.code==100){
            if(data.menuItems&&data.menuItems.length>0){
                $scope.menuItems=data.menuItems;
                $scope.menuItems.unshift({name: "首页",url:""});
            }
        }else{
            toastMessage(data.desc);
        }
    }).error(function(data, status, headers, config){
        hideLoading();
        showErrorMessage(status);
    });
}